export default __webpack_public_path__ + "static/media/services_02.e4392466.jpg";